import { FreeThingsProduct } from '@/types'
import { ProductTileWrap, ListNumber, Wrapper, Title, ProductImage, Main } from './FreeThingsToDoCarousel.styles'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import Container from '../Container'
import { useState } from 'react'
import { LIST_SIZE } from '@/constant/segment'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { ProductListCarousel, SwiperHeadingContainer, SwiperButtons, SwiperLeft, SwiperRight } from '../Swiper.styles'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'
import { useRouter } from 'next/router'
import { generateHtmlSafeId } from '@/helpers/WidgetHelper'

export const FreeThingsToDoCarousel: React.FC<{
  title: string
  products: FreeThingsProduct[]
  numberedList?: boolean
  handlerKey?: string
  exceedContainer?: boolean
  region: string
}> = ({ title, products, numberedList = false, region }) => {
  const [lastIndex, setLastIndex] = useState(LIST_SIZE)

  const defaultProperties = useDefaultProperties()
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  const router = useRouter()
  const lang = router.query.lang
  const componentId = generateHtmlSafeId(title)
  const widgetPrev = `${componentId}-prev`
  const widgetNext = `${componentId}-next`

  const handlePrev = () => {
    if (lastIndex === LIST_SIZE) return
    setLastIndex(lastIndex - 1)
  }

  const handleNext = () => {
    if (lastIndex === products.length) return
    setLastIndex(lastIndex + 1)
  }

  return (
    <>
      {products && (
        <Container spacing="XXL">
          <SwiperHeadingContainer>
            <Heading size="XL">{title}</Heading>
            {products?.length > LIST_SIZE && (
              <SwiperButtons>
                <SwiperLeft data-testid={widgetPrev} className={widgetPrev} onClick={handlePrev}></SwiperLeft>
                <SwiperRight data-testid={widgetNext} className={widgetNext} onClick={handleNext}></SwiperRight>
              </SwiperButtons>
            )}
          </SwiperHeadingContainer>
          <Spacing />
          <ProductListCarousel>
            <Swiper
              modules={[Navigation]}
              navigation={{ prevEl: `.${widgetPrev}`, nextEl: `.${widgetNext}` }}
              breakpoints={{
                0: {
                  spaceBetween: 16,
                  slidesPerView: 'auto',
                },
                768: {
                  spaceBetween: 16,
                  slidesPerView: 3,
                },
                1100: {
                  spaceBetween: 24,
                  slidesPerView: 4,
                },
              }}
            >
              {products?.map(({ id, image, name, urlSegment }, index) => (
                <SwiperSlide key={index}>
                  <ProductTileWrap>
                    {numberedList && <ListNumber>{index + 1}</ListNumber>}
                    {/* TODO: fix url */}
                    <Wrapper href={`${baseUrl}/${lang}/${region}/free-things/${urlSegment}`} onClick={() => {}}>
                      <ProductImage
                        style={{ backgroundImage: image ? `url(${image})` : 'none' }}
                        className="product-tile__image"
                      ></ProductImage>
                      <Main>
                        <Title>{name}</Title>
                      </Main>
                    </Wrapper>
                  </ProductTileWrap>
                </SwiperSlide>
              ))}
            </Swiper>
          </ProductListCarousel>
        </Container>
      )}
    </>
  )
}

export default FreeThingsToDoCarousel
